import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, useFieldArray } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import removeImg from "assets/svgs/close.svg";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection, addSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import { isObjectNotEmpty } from "helpers/functions";

const TeamMembers = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const [selectedImages, setSelectedImages] = useState([]);

  const { loading, error, section } = useSelector((state) => state.section);

  const {
    control,
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      items: section?.items,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: "items",
  });

  const addItems = () => {
    append({
      image: "",
      title: { ar: "", en: "" },
      position: { ar: "", en: "" },
    });
  };

  useEffect(() => {
    if (fields?.length === 0 && !isObjectNotEmpty(section)) {
      addItems();
    }
  }, [fields]);

  useEffect(() => {
    dispatch(
      getSection({
        page: "about",
        slug: "teamWork",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
  }, [reset, section]);

  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    const itemsWithoutImage = data.items.filter(
      (item, index) => item.image === ""
    );
    if (itemsWithoutImage.length > 0) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }

    dispatch(
      editSection({
        slug: "teamWork",
        page: "about",
        data: { section: data },
      })
    );
    // if (section?.items?.length > 0) {
    // }
    //  else {
    //   const newData = { section: { title: "teamWork", ...data } };
    //   dispatch(
    //     addSection({
    //       page: "about",
    //       data: newData,
    //       slug: "teamWork",
    //     })
    //   );
    // }
  };

  useEffect(() => {
    setValue(`sectionSubTitle.ar`, section?.sectionSubTitle?.ar || "");
    setValue(`sectionSubTitle.en`, section?.sectionSubTitle?.en || "");
    setValue(`sectionDescription.ar`, section?.sectionDescription?.ar || "");
    setValue(`sectionDescription.en`, section?.sectionDescription?.en || "");

    section?.items?.forEach((item, index) => {
      setValue(`items[${index}].image`, item?.image || "");

      setValue(`items[${index}].title.ar`, item?.title?.ar || "");
      setValue(`items[${index}].title.en`, item?.title?.en || "");
      setValue(`items[${index}].position.ar`, item?.position?.ar || "");
      setValue(`items[${index}].position.en`, item?.position?.en || "");
    });
  }, [section, setValue]);

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="card">
          <div className="card-body">
            <Col xl={12}>
              <div className="add-multi-component">
                <Row>
                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"subTitle"} />
                        <>
                          {" "}
                          (<FormattedMessage id={"arabic-language"} />){" "}
                        </>
                      </h5>
                      {/* Arabic subtitle Input */}
                      <input
                        name={`sectionSubTitle.ar`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionSubTitle.ar`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 30,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionSubTitle?.ar?.message && (
                        <p className="error-hint">
                          {errors?.sectionSubTitle?.ar?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* English subtitle Input */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"subTitle"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"english-language"} />){" "}
                        </>
                      </h5>
                      <input
                        name={`sectionSubTitle.en`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionSubTitle.en`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 30,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionSubTitle?.en?.message && (
                        <p className="error-hint">
                          {errors?.sectionSubTitle?.en?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* =========================================================================================== */}
                  {/* Arabic description Input */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"arabic-language"} />){" "}
                        </>
                      </h5>
                      <textarea
                        name={`sectionDescription.ar`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionDescription.ar`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 200,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionDescription?.ar?.message && (
                        <p className="error-hint">
                          {errors?.sectionDescription?.ar?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* English description Input */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"english-language"} />){" "}
                        </>
                      </h5>
                      <textarea
                        name={`sectionDescription.en`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionDescription.en`, {
                          required: formatMessage({ id: "requiredField" }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 200,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionDescription?.en?.message && (
                        <p className="error-hint">
                          {errors?.sectionDescription?.en?.message}
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <Row>
              <div className="card-head my-5">
                <h4>
                  <FormattedMessage id={"teamMembers"} />
                </h4>
              </div>
              {fields?.length > 0 &&
                fields?.map((item, index) => {
                  return (
                    <Col sx={12} md={6} key={item.id}>
                      <div className="add-multi-component mt-4">
                        <Row>
                          <div className="form-group required">
                            <h5>
                              <FormattedMessage id={"image"} />
                            </h5>
                            <ImageUpload
                              selectedImage={{
                                path: selectedImages[index]?.path || item.image,
                              }}
                              setSelectedImage={(image) => {
                                setSelectedImages((prevImages) => {
                                  const updatedImages = [...prevImages];
                                  updatedImages[index] = image;
                                  return updatedImages;
                                });
                                setValue(`items[${index}].image`, image.path);
                              }}
                            />
                          </div>
                          {/* Arabic Title Input */}
                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"name"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"arabic-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].title.ar`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].title.ar`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 30,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.title?.ar?.message && (
                                <p className="error-hint">
                                  {errors?.items?.[index]?.title?.ar?.message}
                                </p>
                              )}
                            </div>
                          </Col>
                          {/* =========================================================================================== */}

                          {/* English Title Input */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"name"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"english-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].title.en`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].title.en`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 30,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.title?.en?.message && (
                                <p className="error-hint">
                                  {errors?.items[index]?.title?.en?.message}
                                </p>
                              )}
                            </div>
                          </Col>
                          {/* =========================================================================================== */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"position"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"arabic-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].position.ar`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].position.ar`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 200,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.position?.ar
                                ?.message && (
                                <p className="error-hint">
                                  {errors?.items[index]?.position?.ar?.message}
                                </p>
                              )}
                            </div>
                          </Col>

                          {/* =========================================================================================== */}

                          <Col xs={12} xl={6}>
                            <div className="form-group">
                              <h5>
                                <FormattedMessage id={"position"} />

                                <>
                                  {" "}
                                  (<FormattedMessage
                                    id={"english-language"}
                                  />){" "}
                                </>
                              </h5>
                              <input
                                name={`items[${index}].position.en`}
                                type="text"
                                className="form-control form-outline"
                                {...register(`items[${index}].position.en`, {
                                  required: formatMessage({
                                    id: "requiredField",
                                  }),
                                  minLength: {
                                    value: 3,
                                    message: formatMessage({ id: "minLength" }),
                                  },
                                  maxLength: {
                                    value: 200,
                                    message: formatMessage({ id: "maxLength" }),
                                  },
                                })}
                              />

                              {errors?.items?.[index]?.position?.en
                                ?.message && (
                                <p className="error-hint">
                                  {errors?.items[index]?.position?.en?.message}
                                </p>
                              )}
                            </div>
                          </Col>

                          {/* Remove Button */}
                          {fields.length > 1 && (
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="removeImg"
                            >
                              <img src={removeImg} alt="Remove" />
                            </button>
                          )}
                        </Row>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </div>
        <Row>
          <Col lg={4} xs={12} className="text-left mb-3">
            <button
              type="button"
              className="btn btn-green add_new_section__ w-100"
              onClick={addItems}
            >
              <FormattedMessage id={"addCollection"} />
            </button>
          </Col>
        </Row>
        <SaveChangesButton />
      </form>
    </div>
  );
};

export default TeamMembers;
